const XbsngSubmStatusSearchApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/xbsng-subm-status-search/get`,
};

export default XbsngSubmStatusSearchApiUrls